exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".XhhhFk3GOgvQFst9pJ5N2{width:100%;font-size:12px}html[dir] .XhhhFk3GOgvQFst9pJ5N2{margin-top:20px;text-align:center}._2WGQ7cDRNOaNQt0TdNh6XQ{width:100%;font-size:12px}html[dir] ._2WGQ7cDRNOaNQt0TdNh6XQ{margin-top:8px}html[dir=ltr] ._2WGQ7cDRNOaNQt0TdNh6XQ{text-align:right}html[dir=rtl] ._2WGQ7cDRNOaNQt0TdNh6XQ{text-align:left}", ""]);
// Exports
exports.locals = {
	"systemMessage": "XhhhFk3GOgvQFst9pJ5N2",
	"errorMessage": "_2WGQ7cDRNOaNQt0TdNh6XQ"
};